import React, {useEffect, useState} from 'react';
import {Button, Col, Container, Row} from 'react-bootstrap';
import {useChangePage} from "../../../Hooks/NavigationHooks";
import {Glyphicon} from "../../Common/GlyphIcon";

import {service as UserService} from '../../../Services/UserService';

import {useCheckAuth} from "../../../Hooks/RouteHooks";
import {useMakePageRequest} from "../../../Hooks/RequestHooks";
import {usePermission} from "../../../Hooks/PermissionHooks";

import {useContextIndependentPage} from "../../../Hooks/ContextBuilderHooks";
import {useClassNames} from "../../../Hooks/StyleHooks";

import {StreamBankPageHeader} from '../../Common/StreamBankPageHeader';
import {UsersTable} from './Table'
import {UsersTableFilter} from './TableFilter'


export const UsersIndexPage = props => {
    useCheckAuth();
    useContextIndependentPage();

    const classNames = useClassNames('sb-users-index-page');
    const makePageRequest = useMakePageRequest();
    const permission = usePermission();
    const changePage = useChangePage();

    const [users, setUsers] = useState(null);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        makePageRequest(
            () => UserService.Get(),
            (x) => setUsers(x.result),
        );
    };

    return <Container className={classNames}>
        <div>
            <StreamBankPageHeader
                Title={"Users"}
            />
            <Row>
                <Col xs={12} md={6}><h2>Users</h2></Col>
                <Col xs={12} md={6}>
                    {
                        permission('create_user') ?
                            <Button variant="link" className="float-right h3" onClick={() => changePage("/users/new")}>
                                <Glyphicon glyph="plus-sign">Add User</Glyphicon>
                            </Button>:
                            null
                    }
                </Col>
            </Row>
            <div>
                <hr className="special-hr"/>
            </div>
            <Row>
                <Col xs={12}>
                    <UsersTable
                        FilterComponent={UsersTableFilter}
                        Data={users}
                    />
                </Col>
            </Row>
        </div>
    </Container>;
};
